import { render, staticRenderFns } from "./ClientBalanceReportDetailed.vue?vue&type=template&id=606a95d3&scoped=true&"
import script from "./ClientBalanceReportDetailed.vue?vue&type=script&lang=js&"
export * from "./ClientBalanceReportDetailed.vue?vue&type=script&lang=js&"
import style0 from "./ClientBalanceReportDetailed.vue?vue&type=style&index=0&id=606a95d3&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606a95d3",
  null
  
)

export default component.exports